import React from "react";
interface ContentLayoutProps {
	children: React.ReactNode;
}

const ContentLayout = ({ children }: ContentLayoutProps) => {
	return (
		<div className="at-ContentLayout l--master__container container container--base">
			{children}
		</div>
	);
};

export default ContentLayout;
